const basketConfig = {
  maxProductsNum: 10,

  maxRecipesNum: 4,
  minRecipesNum: 2,

  portions: {
    default: 2,
    allowed: [1, 2, 3, 4, 5, 8],
  },
}

// eslint-disable-next-line import/no-default-export
export default basketConfig
